import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

//  @Component({
//    selector: 'lib-component',
//    template: `
//      <form [formGroup]="form" (ngSubmit)="submit(userModel)">
//        <formly-form [model]="userModel" [fields]="userFields">
//          <button type="submit" class="btn btn-default">Submit</button>
//        </formly-form>
//      </form>
//    `
//  })

@Component({
   selector: 'lib-component',
   template: `
     <h2> Samle Text </h2>
   `
 })
export class LibComponent extends FieldType {
  //  form = new FormGroup({});
  //  userModel = { email: 'email@gmail.com',password: '' };
  //  userFields: Array<FormlyFieldConfig> = [
  //    {
  //      key: 'email',
  //      type: 'input',
  //      templateOptions: {
  //        type: 'email',
  //        label: 'Email Address:',
  //      placeholder: 'Enter Email',
  //        required: true
  //      }
  //    },
  //    {
  //      key: 'password',
  //      type: 'input',
  //      templateOptions: {
  //        type: 'password',
  //        label: 'Password',
  //        placeholder: 'Enter Password',
  //        required: true
  //      }
  //    }
  //  ];

  //  submit(user) {
  //    console.log(user);
  //  }
}
